import { Component, Input, OnInit } from '@angular/core';
import { Employee } from 'src/app/models/firebase/employee';
import { LandingPage } from 'src/app/models/firebase/landing-page';
import { AuthService } from 'src/app/service/auth/auth.service';
import { EmployeesService } from 'src/app/service/employees/employees.service';
import { IMAGES_RESOLUTIONS } from 'src/app/utils/image-config';

@Component({
  selector: 'app-our-employees',
  templateUrl: './our-employees.component.html',
  styleUrls: ['./our-employees.component.scss']
})
export class OurEmployeesComponent implements OnInit {

    @Input() homeView: boolean = false;
    @Input() landingPageData: LandingPage;
    IMAGES_RESOLUTIONS = IMAGES_RESOLUTIONS;
    employees: Employee[] = [];

    constructor(
        protected authService: AuthService,
        private employeeService: EmployeesService,
    ) {}
    async ngOnInit(): Promise<void> {
        this.employees = await this.employeeService.getEmployees(this.authService.projectId);
        this.employees.sort((a, b) => a.orderIndex - b.orderIndex);
    }

}
